import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import { useFilteredNavigation } from '../../utils/navigation';
import LanguageSelector from '../common/LanguageSelector';
import Icon from '../Icon/Icon';
import './Navigation.scss';

const Navigation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { navigationItems } = useFilteredNavigation();

    const handleCreateClick = (path) => {
        navigate(`${path}/create`);
    };

    return (
        <nav className="navigation">
            <div className="nav-header">
                 <Link to="/">
                    <img src="/sloot_logo.svg" alt="Sloot Logo" className="nav-logo" width="200" />
                </Link>
            </div>
            <ul className="nav-menu">
                {navigationItems.map((item) => (
                    <li key={item.path} className="nav-resource">
                        <div className="nav-item-container">
                            <Link
                                to={item.path}
                                className={`nav-link ${location.pathname === item.path || location.pathname.startsWith(item.path + '/') ? 'active' : ''}`}
                            >
                                <Icon icon={item.icon} className="nav-icon" size="sm" />
                                <span className="nav-label">{t(item.labelKey)}</span>
                            </Link>
                            {item.add_create_button && (
                                <button
                                    onClick={() => handleCreateClick(item.path)}
                                    className="nav-create-button"
                                    title={t('common.create')}
                                >
                                    <Icon icon="plus" size="xs" />
                                </button>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
            <div className="nav-footer">
                <LanguageSelector
                    variant="dropdown"
                    showLabel={false}
                />
            </div>
        </nav>
    );
};

export default Navigation;